import React from 'react';
import { Link } from 'react-router-dom';

const CategoryBannerStrip = ({ banners }) => {
  if (!banners || banners.length === 0) return null;

  return (
    <div className="py-3">
      <div className="flex gap-3 overflow-x-auto scrollbar-hide snap-x snap-mandatory px-4">
        {banners.map((banner) => (
          <Link
            key={banner._id}
            to={`/user/browse/${encodeURIComponent(banner.categoryLevel1)}/${encodeURIComponent(banner.categoryLevel2 || '')}${banner.categoryLevel3 ? '/' + encodeURIComponent(banner.categoryLevel3) : ''}`}
            className="flex-shrink-0 w-[85%] snap-center"
          >
            <div className="relative h-[200px] rounded-xl overflow-hidden bg-gray-100">
              {banner.imageUrl ? (
                <img
                  src={banner.imageUrl}
                  alt={banner.title || banner.categoryLevel3 || banner.categoryLevel2}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              ) : (
                <div className="w-full h-full bg-gradient-to-br from-gray-800 to-gray-900" />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4 flex items-end justify-between">
                <div>
                  <h4 className="text-lg font-bold text-white leading-tight">
                    {banner.title || banner.categoryLevel3 || banner.categoryLevel2}
                  </h4>
                  {banner.subtitle && (
                    <p className="text-xs text-white/70 mt-0.5">{banner.subtitle}</p>
                  )}
                </div>
                <span className="bg-white/90 text-black text-[11px] font-semibold px-3 py-1 rounded-full flex-shrink-0">
                  View All
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default CategoryBannerStrip;
